<template>
  <div>
    <event-list />
  </div>
</template>

<script>
  import EventList from '@/components/eventV2/EventList.vue'

  export default {
    components: {
      EventList
    }
  }
</script>
